import { usePhoneNumberContext } from 'calling-ui-library/calling-remote-redesign/contexts/PhoneNumberContext';
import { Metrics, OPEN_REMOTE } from 'calling-remote-common/utils/Metrics';
import { useOpenRemoteEventHandler } from '../../common/hooks/useOpenRemoteEventHandler';
export const useHandleOpenRemoteMessage = openRemote => {
  const {
    setRawToNumber,
    setSelectedCallableObject
  } = usePhoneNumberContext();
  useOpenRemoteEventHandler({
    onOpenRemoteMessage: message => {
      openRemote();
      Metrics.counter(OPEN_REMOTE, {
        source: 'open-remote-message'
      }).increment();
      const {
        callableObject
      } = message.payload;
      if (callableObject) {
        setSelectedCallableObject({
          name: callableObject.name,
          objectTypeId: callableObject.objectTypeId,
          objectId: callableObject.objectId
        });
        setRawToNumber(callableObject.phoneNumber);
      }
    }
  });
};